import {ImportAgreementType} from "@features/accounts/run-tenant-payouts/model/run-payouts.model";
import {TransactionSource} from "@features/leasing/leasing.model";

export class JobRunConfig {
  loading: boolean = false;
  enabled: boolean = false;
  jobStatus: string | null = null;
  lockedOn: string | null = null;
  maxTimeout: string | null = null;
  schedulerConfig: string | null = null;
  id: string | null = null;
  name: string | null = null;
  status: string | null = null;

  constructor(obj: any) {
    Object.assign(this, obj);
  }
}

export const productJobs = [
  {
    name: 'Import All Products',
    id: 'products_job_import_products'
  },
  {
    name: 'Import All Product Inventory',
    id: 'products_job_import_product_inventory'
  },
  {
    name: 'Import Retailer Products',
    id: 'products_job_import_retailer_products'
  },
  {
    name: 'Import Retailer Product Inventory',
    id: 'products_job_import_retailer_product_inventory'
  },
];

export class ImportProductsConfig {
  correlationId: string | null = null;
  retailerId?: number | null;
  paymentConfigUuid?: string | null;
  transactionSources: TransactionSource[] = [];
  linkStatus: ProductLinkStatus | null = ProductLinkStatus.UNLINKED;
  importAgreementType: ImportAgreementType | null = ImportAgreementType.MASTER;
  includePaymentConfigUuids?: string[] = [];
  excludePaymentConfigUuids?: string [] = [];
}

export enum ProductLinkStatus {
  ALL = 'ALL',
  ALL_SOLD = 'ALL_SOLD',
  UNLINKED = 'UNLINKED',
  UNLINKED_ERROR = 'UNLINKED_ERROR'
}
